<template>
  <div class="scoped-notification-container">
    <div
      class="scoped-notification"
      :class="`scoped-notification--${type}`"
    >
      <span class="scoped-notification__icon" v-html="icon"></span>
      <span v-html="message"></span>
    </div>
  </div>
</template>

<script>
import iconInfo from '@/assets/icons/iconInfo.svg?raw';
import iconError from '@/assets/icons/iconError.svg?raw';
import iconSuccess from '@/assets/icons/iconSuccess.svg?raw';
import iconWarning from '@/assets/icons/iconWarning.svg?raw';

export default {
  name: 'ScopedNotification',
  props: {
    type: {
      type: String,
      default: 'info',
    },
    message: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      const icons = {
        info: iconInfo,
        error: iconError,
        success: iconSuccess,
        warning: iconWarning,
      };
      return icons[this.type] || icons.info;
    },
  },
};
</script>


<style lang="scss" scoped>
.scoped-notification-container {
  height: 4.6875rem;

  @media screen and (min-width: 790px) {
    height: 3.125rem;
  }
}

.scoped-notification {
  position: fixed;
  top: 55px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  min-height: 2.875rem;
  font-size: 0.8125rem;
  background-color: $alert-grey;
  color: $dark-moon;
  z-index: 999;
  box-sizing: border-box;

  &__icon {
    display: inline-block;
    margin-right: 0.75rem;
    vertical-align: middle;
  }

  svg {
    display: inline-block;
    width: 1.25rem;
    height: 1.25rem;
    color: inherit;
    fill: currentColor;
  }

  a {
    text-decoration: underline !important;
  }

  &--info {
    background-color: $alert-dark-grey;
    color: $white;
  }

  &--success {
    background-color: $alert-green;
    color: $white;
  }

  &--error {
    background-color: $alert-red;
    color: $white;
  }

  &--warning {
    background-color: $alert-yellow;
  }

  @media screen and (min-width: 440px) {
    padding: 1rem;
  }

  @media screen and (min-width: 1200px) {
    left: 180px;
  }
}
</style>

